import { CardsMessages } from '../models/CardsMessages';
import { StudentSkillStates } from '../models/StudentSkillState';
import { StudentTour } from '../models/StudentTour';
import { onlyNotPassed } from './onlyNotPassed';

//const MAX_CARDS_QUANTITY = 3;

export const filterAndSliceSuggested = (element: StudentSkillStates[], tourMode: StudentTour) => {
  let cardMessage = CardsMessages.DEFAULT;
  element = element.filter(onlyNotPassed);
  if (element.length === 0) {
    cardMessage =
      tourMode === StudentTour.ALL_SKILLS
        ? CardsMessages.VIEW_SUGGESTED_COMPLETED_ALL_SKILLS
        : CardsMessages.VIEW_SUGGESTED_COMPLETED_UNITS;
  }

  return { element: element, cardMessage: cardMessage };
};
